import React from "react";
import { Box } from "@mui/material";

export default function AppBackground({ children }) {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        position: "relative",
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #f9fcff 0%, #f6fbff 45%, #eef6ff 100%)",
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <Box
          component="svg"
          viewBox="0 0 500 420"
          preserveAspectRatio="none"
          sx={{
            position: "absolute",
            top: { xs: -26, sm: -44 },
            right: { xs: -138, sm: -58 },
            width: { xs: 375, sm: "42vw" },
            minWidth: { sm: 460 },
            maxWidth: { sm: 680 },
            height: { xs: 330, sm: 430 },
          }}
        >
          <path
            d="M176 0 C171 31 171 58 176 82 L175 88 C187 120 202 145 226 158 C254 174 298 170 337 181 C386 195 397 241 410 288 C424 340 455 382 500 420 L500 0 Z"
            fill="rgba(0, 104, 255, 0.055)"
          />
        </Box>

        <Box
          component="svg"
          viewBox="0 0 540 400"
          preserveAspectRatio="none"
          sx={{
            position: "absolute",
            left: { xs: -22, sm: 0 },
            bottom: { xs: -2, sm: -18 },
            width: { xs: 420, sm: "54vw" },
            minWidth: { sm: 580 },
            maxWidth: { sm: 780 },
            height: { xs: 260, sm: 335 },
          }}
        >
          <path
            d="M0 400 L0 210 C30 187 56 158 87 128 C112 104 127 103 149 113 C176 126 190 145 183 178 C174 219 158 255 162 291 C167 327 201 350 233 377 L260 400 Z"
            fill="rgba(0, 104, 255, 0.045)"
          />
        </Box>
      </Box>

      <Box sx={{ position: "relative", zIndex: 1, minHeight: "100dvh" }}>
        {children}
      </Box>
    </Box>
  );
}
